import { EnvironmentModel } from './environment.model';
import { firebaseConfig } from './firebase';

export const environment: EnvironmentModel = {
  apiRoot: 'api',
  production: true,
  firebase: firebaseConfig
};
